import { VideoCropPosition } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Scene';

export type CropSelectionOutlinePositions = {
  top: number;
  left: number;
  width: number;
  height: number;
};

export interface CropSelectionOutlineProps {
  facialBounds?: Record<string, VideoCropPosition>;
  personBounds?: Record<string, VideoCropPosition>;
  positions: CropSelectionOutlinePositions;
  updatePositions: (newPositions: CropSelectionOutlinePositions) => void;
  maintainAspectRatio?: boolean;
  minimumWidthPercentage?: number;
  aspectRatio: number;
  videoAspectRatio: number;
}

export enum ResizeDirectionEnum {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left'
}
